module.exports = __webpack_public_path__ + "static/media/wsu.c2f3526b.png";